import axios, { AxiosResponse } from "axios";
import {
  // isDecisionModel,
  // isPriceModel,
  Model,
  ModelError,
} from "../features/models/types/model";
import { Cap } from "../types/caps";
import { differenceJSON } from "./difference";
import moment from "moment";
// import { Models } from "../features/models/types/model";
// import { ApiModel, toApiModel, toModel } from "./models";

let baseUrl: string = "/api/v1/Underwriting";
const baseModel: string = `/api/v1/Underwriting/Models`;
const baseCaps: string = `/api/v1/Caps`;

// export const getModels = async (): Promise<Models[]> => {
//   let d = await axios.get(baseModel);
//   return d.data.map(toModel);
// };
export const getCaps = async (): Promise<Cap[]> => {
  let d = await axios.get(`${baseCaps}`);
  return d.data;
};

export const getErrors = async (
  startDate: string,
  endDate: string,
  modelID?: number
): Promise<ModelError[]> => {
  let d = await axios.get(`${baseUrl}/Errors`, {
    params: { modelID, startDate, endDate },
  });
  return d.data;
};

export type SortDto = {
  sortOrder: number;
};

export type ApplicationField = {
  name: string;
  preReqID: number | null;
};

export const updateSortOrder = async (
  modelID: number,
  s: SortDto
): Promise<void> => {
  await axios.post(`${baseModel}/${modelID}/SortOrder`, s);
};

// export const createModel = async (model: Model): Promise<Model> => {
//   let d = await axios.post(baseModel, toApiModel(model));
//   return d.data;
// };

// export const updateModel = async (updatedModel: Model): Promise<Model> => {
//   let d: AxiosResponse<ApiModel> = await axios.post<ApiModel>(
//     `${baseModel}/${updatedModel.modelID}`,
//     toApiModel(updatedModel)
//   );

//   return toModel(d.data) ?? updatedModel;
// };
export const deleteModel = async (modelID: number): Promise<void> => {
  await axios.delete(`${baseModel}/${modelID}`);
  return;
};

export const getFields = async (): Promise<ApplicationField[]> => {
  let d = await axios.get(`${baseUrl}/Lookups/Fields`);
  return d.data;
};

export const getAllApplicationFields = async (): Promise<ApplicationField[]> => {
  let d = await axios.get(`${baseUrl}/Lookups/ApplicationFields`);
  return d.data;
};

// export const getErrors = async (filter:ErrorFilter): Promise<ErrorFilter> => {
//   let d = await axios.get(`${baseUrl}/Errors`,filter);
//   return d.data;
// };

// export const getUTU = async (filter:ErrorFilter): Promise<string> => {
//   let d = await axios.get(`${baseUrl}/UnableToUnderwrite`,filter);
//   return d.data;
// };

export const createCap = async (updatedCap: Cap): Promise<Cap> => {
  const payload: Cap = {
    ...updatedCap,
    customerTypes: updatedCap.customerTypes ?? [],
  };
  const d = await axios.post(baseCaps, payload);
  return d.data;
};
export const updateCap = async (updatedCap: Cap): Promise<Cap> => {
  const payload: Cap = {
    ...updatedCap,
    customerTypes: updatedCap.customerTypes ?? [],
  };
  const d = await axios.post(`${baseCaps}/${updatedCap.capId}`, payload);
  return d.data;
};

export const deleteCap = async (capID: number): Promise<void> => {
  await axios.delete(`${baseCaps}/${capID}`);
  return;
};

// export const getModel = async (
//   modelID: number,
//   history?: number
// ): Promise<Model | null> => {
//   let r = await axios.get<ApiModel>(`${baseModel}/${modelID}`, {
//     params: {
//       history: history,
//     },
//   });
//   return toModel(r.data);
// };

export const getHistory = async (
  modelID: number,
  prevModel: any,
  source: any
): Promise<any> => {
  let historyData: any[] = [];

  function buildHistoryArray(count: number): any {
    return axios
      .get(`${baseModel}/${modelID}/?history=${count}`, {
        cancelToken: source.token,
      })
      .then(function (response) {
        const success: number = 200;
        let { status, data } = response;
        if (status === success) {
          const getChanges = differenceJSON(data, prevModel);
          getChanges &&
            historyData.push({
              changes: { ...getChanges },
            });
          prevModel = data;
          // prevModel is the last iterated model on a success for 200
          count++;
          return buildHistoryArray(count);
        }
      })
      .catch((err) => {
        // handle this
        console.log(err);
      });
  }
  return buildHistoryArray(1).then(() =>
    historyData.length !== 0 ? { data: historyData.reverse() } : null
  );
};
